// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2078":"779cd2dd","4746":"60405333","9245":"60405333","9520":"60405333","9796":"60405333"}[chunkId] + ".chunk.css";
};